import ProjectItem from './ProjectItem';

export default ProjectItem;
